import { Redirect } from "../../utils/common";
export default () => <Redirect to='/legal/web/privacy' />